import { parseAsInteger, useQueryState } from 'nuqs'
import { useMediaQuery } from 'usehooks-ts'
import { INTEGRATIONS_PER_PAGE } from 'routes/constants'
import { IntegrationCompactType } from 'routes/Integrations/helpers/types'
import { IntegrationsGrid } from '../Grid'
import { IntegrationsPagination } from '../Pagination'
import classes from './IntegrationsContent.module.scss'

export function IntegrationsContent({
  integrations,
  total,
}: {
  integrations: IntegrationCompactType[]
  total: number
}) {
  const [currentPage] = useQueryState('page', parseAsInteger.withDefault(1))

  const isMobile = useMediaQuery('(max-width: 575px)')
  const isDesktop = useMediaQuery('(min-width: 992px)')
  const siblingsValue = isMobile ? 0 : isDesktop ? 2 : 1

  return (
    <>
      {!!integrations?.length && (
        <div className={classes.wrapper}>
          <IntegrationsGrid integrations={integrations} />
          <IntegrationsPagination
            totalCount={total}
            siblingCount={siblingsValue}
            pageSize={INTEGRATIONS_PER_PAGE}
            currentPage={currentPage}
          />
        </div>
      )}
    </>
  )
}
